<template>
  <div>
    <list-vue
      v-bind:busqueda="busqueda"
      v-bind:busquedaTraduccion="busquedaTraduccion"
      v-bind:busquedaMedidas="busquedaMedidas"
      v-bind:opciones="opciones"
      v-bind:moduloTitulo="moduloTitulo"
      v-bind:pantallaTitulo="pantallaTitulo"
      v-bind:rutaConsulta="rutaConsulta"
      v-bind:buttonsPage="buttonsPage"
      v-bind:busquedaCampos="busquedaCampos"
    ></list-vue>
  </div>
</template>
<script type="text/javascript">
import { mapState } from "vuex";
import { mapMutations } from "vuex";
export default {
  data() {
    return {
      //Definimos los nombres generales
      moduloTitulo: this.$root.trans("Reporte General"),
      reporte: false,
      pantallaTitulo: this.$root.trans("Resultado"),
      rutaConsulta: "./reportes-general-beta",
      buttonsPage: [
        // {
        //     type        :   'button',
        //     class       :   'btn btn-xs btn-info pull-right',
        //     route       :   'AuthorsCreate',
        //     text        :   '<i class="fa fa-plus">',
        //     description :   '<i class="fa fa-plus">',
        // }
      ],
      //Definimos los campos de busqueda, sus nombres e incluso tamaño
      busqueda: {
          f___fecha: "",
          f__fecha_asignado: "",
          f___codigo_ficha: "",
          fica___valor_version: "",
          f___descripcion: "",
          f___etapa_actual_id: "",
          f___responsable_actual_id: "",
          f___cali_tipos_nc_id: "",
      },
      busquedaTraduccion: {
          f___fecha: this.$root.trans("F. Creacion"),
          f__fecha_asignado: this.$root.trans("U. Movimiento"),
          f___codigo_ficha: this.$root.trans("Codigo"),
          fica___valor_version: this.$root.trans("Versión"),
          f___descripcion: this.$root.trans("Descripción"),
          f___etapa_actual_id: this.$root.trans("Etapa Actual"),
          f___responsable_actual_id: this.$root.trans("Responsable Actual"),
          f___cali_tipos_nc_id: this.$root.trans("Tipo Ficha"),
      },
      busquedaCampos: {
        f___responsable_actual_id: {
          type: "select",
          options: [],
        },
        f___etapa_actual_id: {
          type: "select",
          options: [],
        },
        f___cali_tipos_nc_id: {
          type: "select",
          options: [],
        },

        // vencimiento: {
        //   type: "date",
        // },
        f___fecha: {
          type: "date",
        },
        f__fecha_asignado: {
          type: "date",
        },
        // fecha_derivado: {
        //   type: "date",
        // },
      },
      busquedaMedidas: {
        f__fecha_asignado: "93px",
        f___fecha: "93px",
        f___codigo_ficha: "93px",
        fica___valor_version: "93px",
        f___descripcion: "250px",
        f___etapa_actual_id: "100px",
        f___responsable_actual_id: "70px",
        f___cali_tipos_nc_id: "100px",
      },
      //definimos las opciones con enlace simple para ello usamos el nombre de la ruta y en caso de eliminar usamos la ruta
      opciones: [],
    };
  },
  computed: {
    ...mapState(["request"]),
  },
  methods: {
    ...mapMutations({ requestSet: "request" }),
  },
  mounted() {
    this.requestSet(this.$route.query);

    if (this.$route.query && this.$route.query.nc) {
      switch (this.$route.query.nc) {
        case "RE":
          this.moduloTitulo = "Reporte Registro";
          break;
        case "NO":
          this.moduloTitulo = "Reporte Información Documentada";
          break;
        case "AU":
          this.moduloTitulo = "Reporte Auditoria";
          break;

        default:
          break;
      }
    }

    this.reporte = this.$route.query.nc;

    if (this.reporte === "NO") {
    } else {
      delete this.busqueda["fica___valor_version"];
      delete this.busquedaTraduccion["fica___valor_version"];
      delete this.busquedaMedidas["fica___valor_version"];

      this.$delete(this.busqueda, "fica___valor_version");
      this.$delete(this.busqueda, 1);

      if (this.reporte === "NC" || this.reporte === "RE") {
        this.busqueda["f___cliente_id"] = "";
        this.busquedaTraduccion["f___cliente_id"] = this.$root.trans("Cliente");
        this.busquedaMedidas["f___cliente_id"] = "90px";

        this.busqueda["f___proveedor_id"] = "";
        this.busquedaTraduccion["f___proveedor_id"] =
          this.$root.trans("Proveedor");
        this.busquedaMedidas["f___proveedor_id"] = "90px";
      }
    }

    this.busqueda["f___proceso_id"] = "";
    this.busquedaTraduccion["f___proceso_id"] = this.$root.trans("Proceso");
    this.busquedaMedidas["f___proceso_id"] = "90px";

    this.busqueda["f___clasificacion_id"] = "";
    this.busquedaTraduccion["f___clasificacion_id"] =
      this.$root.trans("Clasific.");
    this.busquedaMedidas["f___clasificacion_id"] = "90px";

    const data = {
      selects: {
        User2: {},
        generic: {
          code: "id",
          label: "descripcion",
          model: "FichasEtapaNC",
          order: "descripcion",
          nc: this.$route.query.nc,
          where: {
            "cali_etapas_tipo_nc.estado": "A",
          },
          concatena_descripcion: ["nodo_numer", "descrip_clasifica"],
        },
        generic2: {
          code: "id",
          label: "descripcion",
          model: "TipoNC",
          order: "descripcion",
          nc: this.$route.query.nc,
          where: {
            "cali_tipos_nc.estado": "A",
          },
        },
      },
    };
    this.$root
      .Consulta(
        this.$root.UrlBase("selects/init-new"),
        data,
        "post",
        false,
        false,
        false,
        "",
        false
      )
      .then((response) => {
        this.busquedaCampos.f___responsable_actual_id.options = response.User2;
        this.busquedaCampos.f___etapa_actual_id.options = response.generic;
        this.busquedaCampos.f___cali_tipos_nc_id.options = response.generic2;
      });
  },
  created() {
    this.requestSet(this.$route.query);
  },
};
</script>
